import { render } from "./index.vue?vue&type=template&id=6f08add0"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/BaseSingleSpecs/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f08add0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f08add0', __exports__)) {
    api.reload('6f08add0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6f08add0", () => {
    api.rerender('6f08add0', render)
  })

}


export default __exports__